import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { Cell } from '@carnica/ui-kit';
import { ImageCell } from "../../ImageCell/ImageCell";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
export var CellCard = function CellCard(_ref) {
  var item = _ref.item,
    onClear = _ref.onClear,
    _onClick = _ref.onClick,
    metrics = _ref.metrics;
  return /*#__PURE__*/React.createElement("li", _extends({
    key: item.title
  }, metrics), /*#__PURE__*/React.createElement(Cell, {
    className: cx('cell'),
    href: item === null || item === void 0 ? void 0 : item.href,
    leftSide: /*#__PURE__*/React.createElement(ImageCell, {
      isSmall: !!(item !== null && item !== void 0 && item.subtitle),
      src: item === null || item === void 0 ? void 0 : item.image_url,
      type: item.category
    }),
    onClick: function onClick(_ref2) {
      var innerText = _ref2.currentTarget.innerText;
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(innerText);
    },
    rightSide: onClear && /*#__PURE__*/React.createElement(IconCloseRoundStroked, {
      className: cx('icon-close'),
      color: "secondary-invert",
      iconClassName: cx('icon-close__image'),
      onClick: function onClick(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onClear === null || onClear === void 0 ? void 0 : onClear(item.title);
      }
    }),
    subTitle: item === null || item === void 0 ? void 0 : item.subtitle,
    tagName: "a",
    title: item.title,
    view: "clear"
  }));
};